import { useContext } from "react";

// CONTEXTS
import UserAuthContext from "../contexts/userAuthContext";



export const useAuth = () => {
    const context = useContext(UserAuthContext);

    if (!context) {
        throw new Error('useAuth deve ser usado dentro de um UserAuthProvider');
    }

    return context;
}